module.exports = __webpack_public_path__ + "static/media/image 26.796563e2.png";